<script setup lang="ts">
import Icon from './Icon.vue';

defineProps<{ label?: string; disabled?: boolean; indeterminate?: boolean }>();
const model = defineModel<boolean>({ default: false });
</script>

<template>
  <label class="cb" :class="{ 'is-on': model || indeterminate, 'is-disabled': disabled }" @click.stop>
    <input v-model="model" type="checkbox" class="sr-only" :disabled="disabled" />
    <span class="box">
      <Icon v-if="indeterminate && !model" name="plus" :size="11" :stroke="3" class="dash" />
      <Icon v-else-if="model" name="check" :size="12" :stroke="3" />
    </span>
    <span v-if="label || $slots.default" class="label"><slot>{{ label }}</slot></span>
  </label>
</template>

<style scoped>
.cb {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}
.cb.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.box {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  border: 1.5px solid var(--border-strong);
  background: var(--surface-2);
  display: grid;
  place-items: center;
  color: #fff;
  transition: all var(--dur) var(--ease);
}
.is-on .box {
  background: var(--accent);
  border-color: var(--accent);
}
.cb:focus-within .box {
  box-shadow: var(--focus);
}
.dash {
  transform: rotate(0);
}
</style>
